<ng-container *ngFor="let messagePart of messageParts">
  <div *ngIf="messagePart.type === messagePartTypes.SMILE; else text" class="smile-container">
    <app-smile [smile]="$any(messagePart.content)"></app-smile>
  </div>
  <ng-template #text>
    <span [innerText]="messagePart.content" class="comment-text"></span>
  </ng-template>
</ng-container>
